// extracted by mini-css-extract-plugin
module.exports = {"co-branding-banner":"_17Tl0","coBrandingBanner":"_17Tl0","top":"QQPgp","logo-wrapper":"_35huq","logoWrapper":"_35huq","rtl":"z35m8"};